var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    fileDropWrapperMargin: spacing.xSmall,
    fileDropContentPadding: spacing.medium,
    fileDropContentBackgroundColor: colors.porcelain,
    fileDropContentBorderWidth: borders.widthSmall,
    fileDropContentBorderColor: colors.tiara,
    fileDropContentFontFamily: typography.fontFamily,
    fileDropContentIconFontSize: typography.fontSizeXXLarge,
    fileDropContentLabelPadding: spacing.xSmall,
    fileDropContentLabelBrowsePadding: spacing.xxSmall,
    fileDropContentLabelBrowseColor: colors.electric
  };
};
export default generateComponentTheme;